// Bambody v3 shop picker + dynamic sticky ATC.
// Wires the pill/swatch/size/pack buttons to real Shopify variants,
// updates image + price, submits real add-to-cart via fetch.

(function () {
  // ── STYLE → silhouette label map ──
  const STYLE_LABEL = {
    'bambody-hipster-heavy': 'Hipster · Heavy',
    'bambody-hipster-light': 'Hipster · Light',
    'bambody-brief': 'Brief',
    'bambody-panty': 'Panty',
    'bambody-high-waist': 'High-waisted',
    'bambody-boxer': 'Boxer',
  }

  // ── Color hex map (mirrors bambody-color-swatches.js) ──
  const COLOR_MAP = {
    Black: '#1F0E33', Nude: '#E5C6A9', Gray: '#9A9AA0',
    'Dark Blue': '#2A3A6B', 'Dark Purple': '#4B2C7A',
    Pink: '#F5B6C7', Blue: '#8DC3E1', Green: '#B7DAB9', Lace: '#1F0E33',
  }

  function colorSlug(raw) {
    return String(raw || '').toLowerCase()
      .replace(/\s*—\s*/g, '-')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '')
  }

  function stripFlow(raw) {
    return String(raw || '').replace(/^(Heavy|Light)(?:\s+Flow)?\s*—\s*/, '').trim()
  }

  // Format a Shopify Liquid price (cents integer) as "$X.YY" — bypasses the
  // shop's money_format setting so switching variants updates predictably.
  function fmtPrice(cents) {
    const n = Number(cents) || 0
    return '$' + (n / 100).toFixed(2)
  }

  function makeSwatchEl(colorRaw, oos) {
    const parts = stripFlow(colorRaw).replace(/\s+with\s+lace/i, '').split(/\s*\/\s*/).map((s) => s.trim()).filter(Boolean)
    const el = document.createElement('button')
    el.type = 'button'
    el.className = 'sw' + (oos ? ' oos' : '')
    if (parts.length === 1) {
      el.style.background = COLOR_MAP[parts[0]] || '#ccc'
    } else {
      const step = 360 / parts.length
      const stops = parts.map((c, i) => `${COLOR_MAP[c] || '#ccc'} ${i * step}deg ${(i + 1) * step}deg`).join(', ')
      el.style.background = `conic-gradient(from -90deg, ${stops})`
    }
    return el
  }

  // ── Load shop data from serialized JSON script tag ──
  let SHOP_DATA = null
  function loadShopData() {
    const el = document.querySelector('script[data-bam-v3-shop-data]')
    if (!el) return null
    try { return JSON.parse(el.textContent) } catch { return null }
  }

  // ── Selection state ──
  // imageIndex: null = auto-follow the selected color's primary image.
  //             integer = user is browsing via the prev/next arrows.
  //             Reset to null on product/color change so color-driven image swap resumes.
  const S = { handle: null, color: null, size: null, pack: null, added: false, imageIndex: null }

  function currentProduct() {
    return SHOP_DATA?.[S.handle]
  }

  function currentVariant() {
    const p = currentProduct()
    if (!p) return null
    return p.variants.find((v) => v.color === S.color && v.size === S.size && v.pack === S.pack) || null
  }

  // Distinct values available for a given axis, given the currently-selected other axes.
  function availableValues(axis) {
    const p = currentProduct()
    if (!p) return []
    const seen = []
    for (const v of p.variants) {
      if (axis !== 'color' && S.color && v.color !== S.color) continue
      if (axis !== 'size' && S.size && v.size !== S.size) continue
      if (axis !== 'pack' && S.pack && v.pack !== S.pack) continue
      const val = v[axis]
      if (val && !seen.some((x) => x.value === val)) {
        seen.push({ value: val, available: v.available })
      }
    }
    return seen
  }

  // Canonical Bambody size order (XXS → 6XL). Anything not in the map sorts to the end.
  const SIZE_ORDER = ['XX-Small','X-Small','Small','Medium','Large','X-Large','XX-Large','3X-Large','4X-Large','5X-Large','6X-Large']
  const sizeRank = (s) => { const i = SIZE_ORDER.indexOf(s); return i < 0 ? 999 : i }
  // Pack order: single pair → larger bundles, always the same order across products.
  const PACK_ORDER = ['1pk','2pk','3pk','4pk','5pk','6pk']
  const packRank = (s) => { const i = PACK_ORDER.indexOf(s); return i < 0 ? 999 : i }

  // Distinct values across ALL variants of the product (ignoring current selection),
  // used to render the full row even when currently-selected axes filter some out.
  function allValues(axis) {
    const p = currentProduct()
    if (!p) return []
    const seen = []
    for (const v of p.variants) {
      const val = v[axis]
      if (val && !seen.some((x) => x.value === val)) {
        // Aggregate availability: value is "available" if at least one variant with this value is in-stock.
        seen.push({ value: val, available: v.available })
      }
    }
    // Contextual availability: a value is "available" only if an in-stock variant
    // matching the OTHER selected axes exists — size respects the chosen color, pack
    // respects the chosen color+size. Unavailable/nonexistent combos render greyed.
    for (const s of seen) {
      s.available = p.variants.some((v) => {
        if (v[axis] !== s.value || !v.available) return false
        if (axis !== 'color' && S.color && v.color !== S.color) return false
        if (axis === 'pack' && S.size && v.size !== S.size) return false
        return true
      })
    }
    if (axis === 'size') seen.sort((a, b) => sizeRank(a.value) - sizeRank(b.value))
    if (axis === 'pack') seen.sort((a, b) => packRank(a.value) - packRank(b.value))
    return seen
  }

  function selectDefaultAxes() {
    const p = currentProduct()
    if (!p) return
    const firstAvail = p.variants.find((v) => v.available) || p.variants[0]
    S.color = firstAvail.color
    S.size = firstAvail.size
    S.pack = firstAvail.pack
  }

  // Given current selection, if the exact variant doesn't exist, snap to nearest.
  function snapToClosestVariant() {
    const p = currentProduct(); if (!p) return
    if (currentVariant()) return
    // Try to preserve color first, then size, then pack.
    const byColor = p.variants.filter((v) => v.color === S.color && v.available)
    const bySize = byColor.filter((v) => v.size === S.size)
    if (bySize.length) { const v = bySize[0]; S.pack = v.pack; return }
    if (byColor.length) { const v = byColor[0]; S.size = v.size; S.pack = v.pack; return }
    const anyAvail = p.variants.find((v) => v.available) || p.variants[0]
    S.color = anyAvail.color; S.size = anyAvail.size; S.pack = anyAvail.pack
  }

  // ── Renderers ──
  function renderStylePills() {
    const el = document.getElementById('bam-v3-style-group')
    if (!el || !SHOP_DATA) return
    el.innerHTML = Object.keys(SHOP_DATA).map((h) => {
      const label = STYLE_LABEL[h] || (SHOP_DATA[h].title || h)
      return `<button type="button" class="pill-btn${S.handle === h ? ' active' : ''}" onclick="bamV3ShopPickProduct('${h}')">${label}</button>`
    }).join('')
  }

  function renderSwatches() {
    const el = document.getElementById('bam-v3-swatch-row')
    if (!el) return
    el.innerHTML = ''
    for (const { value, available } of allValues('color')) {
      const sw = makeSwatchEl(value, !available)
      sw.title = stripFlow(value)
      if (S.color === value) sw.classList.add('active')
      sw.onclick = () => bamV3ShopSelect('color', value)
      sw.addEventListener('mouseenter', () => previewImageForColor(value))
      sw.addEventListener('mouseleave', () => previewImageForColor(null))
      el.appendChild(sw)
    }
    const cur = document.getElementById('bam-v3-color-label')
    if (cur) cur.textContent = stripFlow(S.color || '')
  }

  // Swap the main <img> to the hovered color's image; pass null to restore the selected color.
  // Dawn/spotlight v1 uses the same pattern (bambody-color-swatches.js).
  function previewImageForColor(colorRaw) {
    const p = currentProduct(); if (!p) return
    const img = document.getElementById('bam-v3-shop-img')
    if (!img) return
    const target = colorRaw || S.color
    const url = mainImageFor(p, target) || p.defaultImage
    if (!url) return
    img.src = url
    img.alt = `${p.title} — ${stripFlow(target)}`
  }

  // Main image for the current (color, pack). Same priority as the PDP
  // (bambody-v3-pdp.js heroFor): the selected variant's own image (set in admin),
  // then any variant of that (color, pack) with an image, then the tagged heroes
  // (bam-pack, bam-color), then any variant of that colour, then the default.
  // Pass colorOverride to preview a hovered color while keeping the selected pack.
  function mainImageFor(p, colorOverride) {
    if (!p) return null
    const color = colorOverride || S.color
    const vs = p.variants || []
    const exact = colorOverride ? null : vs.find((v) => v.color === color && v.size === S.size && v.pack === S.pack && v.image)
    const samePack = vs.find((v) => v.color === color && v.pack === S.pack && v.image)
    const slug = colorSlug(color)
    return exact?.image || samePack?.image
      || (S.pack && p.packImages?.[`${slug}:${S.pack}`]) || p.images?.[slug]
      || vs.find((v) => v.color === color && v.image)?.image || p.defaultImage || null
  }

  function renderSizes() {
    const el = document.getElementById('bam-v3-size-row')
    if (!el) return
    el.innerHTML = allValues('size').map(({ value, available }) =>
      `<button type="button" class="sz-btn${S.size === value ? ' active' : ''}${available ? '' : ' oos'}" onclick="bamV3ShopSelect('size','${value.replace(/'/g, "\\'")}')">${value.replace('X-Small', 'XS').replace('XX-Small', 'XXS').replace('X-Large', 'XL').replace('XX-Large', 'XXL').replace('3X-Large', '3X').replace('4X-Large', '4X').replace('5X-Large', '5X').replace('6X-Large', '6X').replace('Small', 'S').replace('Medium', 'M').replace('Large', 'L')}</button>`,
    ).join('')
  }

  function renderPacks() {
    const el = document.getElementById('bam-v3-pack-row')
    if (!el) return
    const packs = allValues('pack')
    el.innerHTML = packs.map(({ value, available }) => {
      const label = value === '1pk' ? 'Single pair' : value.replace(/pk$/, '-pack') + ' bundle'
      const price = ''
      return `<button type="button" class="pack-btn${S.pack === value ? ' active' : ''}${available ? '' : ' oos'}" onclick="bamV3ShopSelect('pack','${value}')"><span class="pack-name">${label}</span><span class="pack-sub">${price}</span></button>`
    }).join('')
  }

  function renderBuy() {
    const v = currentVariant()
    const priceMain = document.getElementById('bam-v3-price-main')
    const priceSub = document.getElementById('bam-v3-price-sub')
    const atc = document.getElementById('bam-v3-atc-btn')
    if (!v) {
      if (priceMain) priceMain.textContent = 'Unavailable'
      if (priceSub) priceSub.textContent = ''
      if (atc) atc.disabled = true
      syncExpressForm(null)
      return
    }
    if (priceMain) priceMain.textContent = fmtPrice(v.price)
    const packLabel = v.pack === '1pk' ? 'Single pair' : v.pack.replace(/pk$/, '-pack')
    if (priceSub) priceSub.textContent = packLabel
    if (atc) {
      atc.disabled = !v.available
      atc.dataset.variantId = v.id
    }
    syncExpressForm(v)
    // Savings banner: if pack > 1, show a mock savings message
    const banner = document.getElementById('bam-v3-savings-banner')
    const banText = document.getElementById('bam-v3-savings-text')
    if (banner && banText) {
      if (v.pack && v.pack !== '1pk') {
        banner.style.display = 'flex'
        banText.innerHTML = `${v.pack.replace(/pk$/, '-pack')} — silky bamboo, ${packLabel} value`
      } else {
        banner.style.display = 'none'
      }
    }
  }

  // Reveal only the current handle's express-checkout form and pin its hidden
  // variant id to the currently-selected variant. Every other product's form
  // stays hidden. Shopify renders payment_button as a Shop Pay / Apple Pay /
  // PayPal stack — but only if wallets are enabled on the store.
  function syncExpressForm(variant) {
    const row = document.getElementById('bam-v3-express-row')
    if (!row) return
    const forms = row.querySelectorAll('[data-express-handle]')
    forms.forEach((el) => {
      const active = el.dataset.expressHandle === S.handle
      if (active) el.removeAttribute('hidden')
      else el.setAttribute('hidden', '')
    })
    if (!variant) return
    const active = row.querySelector(`[data-express-handle="${S.handle}"]`)
    const idInput = active?.querySelector('[data-express-id]')
    if (idInput) idInput.value = variant.id
  }

  // Effective gallery = [current (color,pack) main, ...shared family media].
  // `p.gallery` (from Liquid) excludes variant-specific heroes (bam-color / bam-pack);
  // the unique main for the selected color+pack is prepended here so the strip stays
  // variant-aware without rendering every combo's hero as a thumbnail.
  function effectiveGallery(p) {
    const shared = Array.isArray(p?.gallery) ? p.gallery : []
    const heroUrl = mainImageFor(p)
    return heroUrl ? [heroUrl, ...shared] : shared
  }

  function renderImage() {
    const p = currentProduct(); if (!p) return
    const el = document.getElementById('bam-v3-shop-img')
    if (!el) return

    const gallery = effectiveGallery(p)
    let url = null
    if (S.imageIndex != null && gallery[S.imageIndex]) {
      // Manual browse mode.
      url = gallery[S.imageIndex]
    } else {
      // Auto/color-follow mode — gallery[0] is always the current color hero.
      url = gallery[0] || null
    }

    if (url) {
      el.src = url
      el.alt = `${p.title} — ${stripFlow(S.color)}`
      el.removeAttribute('data-empty')
    } else {
      // No image for this product/color — clear src so we don't carry a stale image from another product,
      // and mark [data-empty] so CSS can fade it out cleanly.
      el.removeAttribute('src')
      el.alt = p.title
      el.setAttribute('data-empty', '')
    }

    // Prev/next arrows + counter — visible only if multiple images exist.
    const prev = document.getElementById('bam-v3-shop-prev')
    const next = document.getElementById('bam-v3-shop-next')
    const counter = document.getElementById('bam-v3-shop-img-count')
    const showControls = gallery.length > 1
    if (prev) prev.hidden = !showControls
    if (next) next.hidden = !showControls
    if (counter) {
      if (showControls) {
        const displayIdx = S.imageIndex != null ? S.imageIndex : Math.max(0, gallery.indexOf(url))
        counter.textContent = `${displayIdx + 1} / ${gallery.length}`
        counter.hidden = false
      } else {
        counter.hidden = true
      }
    }

    // Also update badge visibility
    const bdg = document.getElementById('bam-v3-shop-bdg')
    if (bdg) bdg.style.display = p.bestseller ? 'inline-block' : 'none'
  }

  // ── Vertical thumbnails column ──
  function renderThumbs() {
    const el = document.getElementById('bam-v3-shop-thumbs')
    if (!el) return
    const p = currentProduct()
    const gallery = effectiveGallery(p)
    if (!p || gallery.length <= 1) { el.innerHTML = ''; el.setAttribute('hidden', ''); return }
    const currentSrc = document.getElementById('bam-v3-shop-img')?.getAttribute('src')
    const activeIdx = (S.imageIndex != null)
      ? Math.min(S.imageIndex, gallery.length - 1)
      : Math.max(0, gallery.indexOf(currentSrc))
    el.removeAttribute('hidden')
    el.innerHTML = gallery.map((url, i) => {
      const cls = 'shop-thumb' + (i === activeIdx ? ' active' : '')
      return `<button type="button" class="${cls}" onclick="bamV3ShopPickImage(${i})" aria-label="Image ${i + 1}"><img src="${url}" alt=""></button>`
    }).join('')
  }

  window.bamV3ShopPickImage = function (idx) {
    const p = currentProduct()
    const gallery = effectiveGallery(p)
    if (idx < 0 || idx >= gallery.length) return
    S.imageIndex = idx
    renderImage()
    renderThumbs()
  }

  // ── Gallery arrows ──
  function stepImage(delta) {
    const p = currentProduct()
    const gallery = effectiveGallery(p)
    if (gallery.length <= 1) return
    const el = document.getElementById('bam-v3-shop-img')
    // Seed from the currently-displayed image so the first click steps from what the user sees,
    // not from index 0 (which would jump past the current color's image on first arrow tap).
    if (S.imageIndex == null) {
      const currentUrl = el?.getAttribute('src')
      const idx = currentUrl ? gallery.indexOf(currentUrl) : -1
      S.imageIndex = idx >= 0 ? idx : 0
    }
    S.imageIndex = (S.imageIndex + delta + gallery.length) % gallery.length
    renderImage()
    renderThumbs()
  }
  window.bamV3ShopPrevImage = function () { stepImage(-1) }
  window.bamV3ShopNextImage = function () { stepImage(1) }

  function renderName() {
    const p = currentProduct(); if (!p) return
    const nameEl = document.getElementById('bam-v3-shop-name')
    const noteEl = document.getElementById('bam-v3-shop-note')
    if (nameEl) nameEl.textContent = p.title
    if (noteEl) noteEl.textContent = p.note
    syncJdgmBadge()
  }

  // Show only the current handle's Judge.me preview badge; hide the rest. Fallback stars
  // stay visible until Judge.me's JS hydrates the badge — once populated, we hide them.
  function syncJdgmBadge() {
    const badges = document.querySelectorAll('#bam-v3-shop-badges [data-bam-badge-handle]')
    let activeBadge = null
    badges.forEach((el) => {
      const active = el.dataset.bamBadgeHandle === S.handle
      if (active) { el.removeAttribute('hidden'); activeBadge = el }
      else el.setAttribute('hidden', '')
    })
    // Hide fallback stars if Judge.me populated the active badge (jdgm injects .jdgm-prev-badge__stars).
    const fallback = document.getElementById('bam-v3-shop-stars-fallback')
    if (!fallback) return
    const hydrated = activeBadge?.querySelector('.jdgm-prev-badge__stars')
    fallback.style.display = hydrated ? 'none' : ''
    // Judge.me sometimes hydrates after DOMContentLoaded — nudge it via its public API if present.
    if (window.jdgm && typeof window.jdgm.reloadPreviewBadges === 'function') {
      // Debounced retry: rerun a beat later to catch async hydration on the newly-visible badge.
      clearTimeout(syncJdgmBadge._retry)
      syncJdgmBadge._retry = setTimeout(() => {
        try { window.jdgm.reloadPreviewBadges() } catch (_) {}
        const later = activeBadge?.querySelector('.jdgm-prev-badge__stars')
        if (later) fallback.style.display = 'none'
      }, 400)
    }
  }

  function renderAll() {
    renderName()
    renderStylePills()
    renderSwatches()
    renderSizes()
    renderPacks()
    renderBuy()
    renderImage()
    renderThumbs()
    renderStickyBar()
  }

  window.bamV3ShopPickProduct = function (handle) {
    if (!SHOP_DATA[handle]) return
    S.handle = handle
    selectDefaultAxes()
    S.added = false
    S.imageIndex = null       // exit manual browse — resume color-follow
    renderAll()
  }

  window.bamV3ShopSelect = function (axis, value) {
    S[axis] = value
    snapToClosestVariant()
    S.added = false
    S.imageIndex = null   // any variant change → resume main-image follow (a size can carry its own image)
    renderAll()
  }

  // Inline SVGs — hoisted so both the shop ATC and the sticky CTA share markup.
  const ICON_CART = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 002 1.58h9.78a2 2 0 001.95-1.57l1.65-7.43H5.12"/></svg>'
  const ICON_CHECK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'
  const SPINNER = '<span class="bam-v3-spin" aria-hidden="true"></span>'

  // Buttons that fire ATC (main shop + sticky bar CTA). Kept in sync during the request.
  function atcButtons() {
    return [
      document.getElementById('bam-v3-atc-btn'),
      document.querySelector('#bam-v3-sticky-bar .sb-cta'),
    ].filter(Boolean)
  }

  function setAtcState(state) {
    atcButtons().forEach((btn) => {
      btn.classList.remove('added')
      btn.disabled = state === 'loading'
      if (state === 'loading') {
        btn.innerHTML = `${SPINNER}<span>Adding…</span>`
      } else if (state === 'success') {
        btn.classList.add('added')
        btn.innerHTML = `${ICON_CHECK}<span>Added</span>`
      }
    })
  }

  function resetAtc() {
    // Re-render the sticky bar to restore its full markup + correct disabled state.
    renderStickyBar()
    const btn = document.getElementById('bam-v3-atc-btn')
    if (btn) {
      btn.classList.remove('added')
      btn.innerHTML = `${ICON_CART} Add to cart`
      const v = currentVariant()
      btn.disabled = !(v && v.available)
    }
  }

  window.bamV3AddToCart = async function () {
    const v = currentVariant()
    if (!v || !v.available) return
    // Instant feedback — flip both buttons BEFORE the network round-trip so the click feels crisp.
    setAtcState('loading')
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
      })
      if (!res.ok) throw new Error('add-to-cart failed')
      const addedItem = await res.json().catch(() => null)
      S.added = true
      setAtcState('success')
      // Notify the cart drawer + any listeners. No coupling to a specific drawer implementation.
      document.dispatchEvent(new CustomEvent('bam:cart:added', { detail: { variantId: v.id, item: addedItem } }))
      setTimeout(() => { S.added = false; resetAtc() }, 1500)
    } catch (e) {
      console.error(e)
      resetAtc()
    }
  }

  // ── STICKY BAR (dynamic: thumbnail + name + variant chips + price + gradient ATC) ──
  function shortSize(s) {
    return String(s || '')
      .replace('XX-Small', 'XXS').replace('X-Small', 'XS').replace('Small', 'S')
      .replace('Medium', 'M')
      .replace('XX-Large', 'XXL').replace('3X-Large', '3X').replace('4X-Large', '4X').replace('5X-Large', '5X').replace('6X-Large', '6X').replace('X-Large', 'XL')
      .replace('Large', 'L')
  }
  function renderStickyBar() {
    const bar = document.getElementById('bam-v3-sticky-bar')
    if (!bar) return
    const p = currentProduct()
    const v = currentVariant()
    if (!p || !v) return
    const url = mainImageFor(p) || p.defaultImage
    const packLabel = v.pack === '1pk' ? 'Single' : v.pack.replace(/pk$/, '-pack')
    bar.innerHTML = `
      <div class="sb-left" onmouseenter="bamV3StickyHover('product')" onmouseleave="bamV3StickyHoverEnd()">
        <button type="button" class="sb-thumb-btn" onclick="bamV3StickyOpen('product', event)">
          ${url ? `<img src="${url}" alt="${p.title}" class="sb-thumb">` : ''}
        </button>
        <button type="button" class="sb-name-btn" onclick="bamV3StickyOpen('product', event)">
          <div class="sb-name">${p.title}</div>
          <div class="sb-chips">
            <button type="button" class="sb-chip" onclick="event.stopPropagation();bamV3StickyOpen('color', event)" onmouseenter="event.stopPropagation();bamV3StickyHover('color')" onmouseleave="event.stopPropagation();bamV3StickyHoverEnd()">${stripFlow(S.color)}</button>
            <button type="button" class="sb-chip" onclick="event.stopPropagation();bamV3StickyOpen('size', event)" onmouseenter="event.stopPropagation();bamV3StickyHover('size')" onmouseleave="event.stopPropagation();bamV3StickyHoverEnd()">${shortSize(S.size)}</button>
            <button type="button" class="sb-chip" onclick="event.stopPropagation();bamV3StickyOpen('pack', event)" onmouseenter="event.stopPropagation();bamV3StickyHover('pack')" onmouseleave="event.stopPropagation();bamV3StickyHoverEnd()">${packLabel}</button>
          </div>
        </button>
      </div>
      <div class="sb-right">
        <div class="sb-price">${fmtPrice(v.price)}</div>
        <button type="button" class="sb-cta" onclick="bamV3AddToCart()"${v.available ? '' : ' disabled'}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 002 1.58h9.78a2 2 0 001.95-1.57l1.65-7.43H5.12"/></svg>
          ${v.available ? 'Add to cart' : 'Sold out'}
        </button>
      </div>
    `
  }

  // ── Popover picker (product / color / size / pack) ──
  // Hover-close is delayed so users can travel from the trigger chip into the popover
  // without it snapping shut. cancelHoverClose fires the moment the cursor enters the
  // popover or another trigger; scheduleHoverClose starts the timer on mouseleave.
  let hoverCloseTimer = null
  const HOVER_CLOSE_MS = 220
  function scheduleHoverClose() {
    clearTimeout(hoverCloseTimer)
    hoverCloseTimer = setTimeout(() => { hoverCloseTimer = null; closePopover() }, HOVER_CLOSE_MS)
  }
  function cancelHoverClose() {
    clearTimeout(hoverCloseTimer)
    hoverCloseTimer = null
  }
  function closePopover() {
    cancelHoverClose()
    document.querySelectorAll('.sb-popover').forEach((el) => el.remove())
  }

  // Show a popover for an axis without toggling. If the same axis is already open,
  // just keep it open (and cancel any pending close). Called by mouseenter.
  window.bamV3StickyHover = function (axis) {
    cancelHoverClose()
    const bar = document.getElementById('bam-v3-sticky-bar')
    if (!bar) return
    const existing = bar.querySelector(`.sb-popover[data-anchor="${axis}"]`)
    if (existing) return   // already showing this axis — cursor moved back onto trigger
    bamV3StickyRender(axis)
  }

  window.bamV3StickyHoverEnd = function () {
    scheduleHoverClose()
  }

  const STYLE_ICON = {
    'bambody-hipster-heavy': 'silhouette-hipster.png',
    'bambody-hipster-light': 'silhouette-hipster.png',
    'bambody-brief': 'silhouette-brief.png',
    'bambody-panty': 'silhouette-panty.png',
    'bambody-high-waist': 'silhouette-high-waist.png',
    'bambody-boxer': 'silhouette-boxer.png',
  }

  function silhouetteURL(handle) {
    // Try common Shopify CDN pattern used by asset_url; fallback to relative
    const filename = STYLE_ICON[handle] || 'silhouette-hipster.png'
    const anyImg = document.querySelector(`img[src*="${filename}"]`)
    if (anyImg) return anyImg.src
    return '/assets/' + filename
  }

  window.bamV3StickyOpen = function (axis, ev) {
    if (ev) ev.stopPropagation()
    const bar = document.getElementById('bam-v3-sticky-bar')
    if (!bar) return
    // Click behavior: toggle. If same popover open, close it.
    const existing = bar.querySelector(`.sb-popover[data-anchor="${axis}"]`)
    if (existing) { closePopover(); return }
    bamV3StickyRender(axis)
  }

  // Shared render — builds and mounts the popover for the given axis.
  // Used by both click (bamV3StickyOpen) and hover (bamV3StickyHover) paths.
  function bamV3StickyRender(axis) {
    const bar = document.getElementById('bam-v3-sticky-bar')
    if (!bar) return
    closePopover()

    const pop = document.createElement('div')
    pop.className = 'sb-popover'
    pop.setAttribute('data-anchor', axis)
    // Hover-bridge: cursor entering the popover cancels the close timer;
    // leaving it schedules one. This keeps the picker sticky while browsing options.
    pop.addEventListener('mouseenter', cancelHoverClose)
    pop.addEventListener('mouseleave', scheduleHoverClose)
    let inner = ''

    if (axis === 'product') {
      const title = 'Choose style'
      const items = Object.keys(SHOP_DATA).map((h) => {
        const active = h === S.handle ? ' active' : ''
        const label = STYLE_LABEL[h] || SHOP_DATA[h].title
        return `<button type="button" class="sb-popover-style${active}" onclick="bamV3ShopPickProduct('${h}');bamV3StickyOpen(null)">
          <img src="${silhouetteURL(h)}" alt="${label}"><span>${label}</span></button>`
      }).join('')
      inner = `<div class="sb-popover-title">${title}</div><div class="sb-popover-styles">${items}</div>`
    } else if (axis === 'color') {
      const items = allValues('color').map(({ value, available }) => {
        const parts = stripFlow(value).replace(/\s+with\s+lace/i, '').split(/\s*\/\s*/).map((s) => s.trim()).filter(Boolean)
        let bg = ''
        if (parts.length === 1) bg = COLOR_MAP[parts[0]] || '#ccc'
        else {
          const step = 360 / parts.length
          bg = 'conic-gradient(from -90deg,' + parts.map((c, i) => `${COLOR_MAP[c] || '#ccc'} ${i * step}deg ${(i + 1) * step}deg`).join(',') + ')'
        }
        const cls = 'sb-popover-swatch' + (S.color === value ? ' active' : '') + (available ? '' : ' oos')
        const val = value.replace(/'/g, "\\'")
        return `<button type="button" class="${cls}" style="background:${bg}" title="${stripFlow(value)}" onclick="bamV3ShopSelect('color','${val}');bamV3StickyOpen(null)"></button>`
      }).join('')
      inner = `<div class="sb-popover-title">Colour</div><div class="sb-popover-swatches">${items}</div>`
    } else if (axis === 'size' || axis === 'pack') {
      const items = allValues(axis).map(({ value, available }) => {
        const label = axis === 'size'
          ? shortSize(value)
          : (value === '1pk' ? 'Single' : value.replace(/pk$/, '-pack'))
        const cls = 'sb-popover-opt' + (S[axis] === value ? ' active' : '') + (available ? '' : ' oos')
        const val = value.replace(/'/g, "\\'")
        return `<button type="button" class="${cls}" onclick="bamV3ShopSelect('${axis}','${val}');bamV3StickyOpen(null)">${label}</button>`
      }).join('')
      const title = axis === 'size' ? 'Size' : 'Pack'
      inner = `<div class="sb-popover-title">${title}</div><div class="sb-popover-grid">${items}</div>`
    } else {
      return
    }
    pop.innerHTML = inner
    bar.appendChild(pop)

    // Click outside closes
    setTimeout(() => {
      document.addEventListener('click', function onDocClick(e) {
        if (!bar.contains(e.target)) {
          closePopover()
          document.removeEventListener('click', onDocClick)
        }
      })
    }, 0)
  }

  // ── Init ──
  document.addEventListener('DOMContentLoaded', () => {
    SHOP_DATA = loadShopData()
    if (!SHOP_DATA || Object.keys(SHOP_DATA).length === 0) return
    const section = document.querySelector('[data-v3-shop]')
    S.handle = section?.dataset.defaultHandle || Object.keys(SHOP_DATA)[0]
    if (!SHOP_DATA[S.handle]) S.handle = Object.keys(SHOP_DATA)[0]
    selectDefaultAxes()
    renderAll()
  })
})();
